import { FieldCacheService, NSARouterMaker, NSARouterMakerResult, NSFRouterMaker } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { EnvService, IStorageSession } from "namirasoft-core";
import { NamirasoftCredentialServer } from "namirasoft-credential";
import { NSNotFoundPage } from "namirasoft-site-react";
import { useReducer } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { CredentialLayout } from "./CredentialLayout";
import { CredentialRoutes } from "./CredentialRoutes";
import AWSEditPage from "./pages/AWSEditPage";
import AWSListPage from "./pages/AWSListPage";
import AWSViewPage from "./pages/AWSViewPage";
import AzureEditPage from "./pages/AzureEditPage";
import AzureListPage from "./pages/AzureListPage";
import AzureViewPage from "./pages/AzureViewPage";
import BasicAuthEditPage from "./pages/BasicAuthEditPage";
import BasicAuthListPage from "./pages/BasicAuthListPage";
import BasicAuthViewPage from "./pages/BasicAuthViewPage";
import DatabaseEditPage from "./pages/DatabaseEditPage";
import DatabaseListPage from "./pages/DatabaseListPage";
import DatabaseViewPage from "./pages/DatabaseViewPage";
import GCPEditPage from "./pages/GCPEditPage";
import GCPListPage from "./pages/GCPListPage";
import GCPViewPage from "./pages/GCPViewPage";
import GitHubEditPage from "./pages/GitHubEditPage";
import GitHubListPage from "./pages/GitHubListPage";
import GitHubViewPage from "./pages/GitHubViewPage";
import GitLabEditPage from "./pages/GitLabEditPage";
import GitLabListPage from "./pages/GitLabListPage";
import GitLabViewPage from "./pages/GitLabViewPage";
import HomePage from "./pages/HomePage";
import HostBasicAuthEditPage from "./pages/HostBasicAuthEditPage";
import HostBasicAuthListPage from "./pages/HostBasicAuthListPage";
import HostBasicAuthViewPage from "./pages/HostBasicAuthViewPage";
import HostTokenAuthEditPage from "./pages/HostTokenAuthEditPage";
import HostTokenAuthListPage from "./pages/HostTokenAuthListPage";
import HostTokenAuthViewPage from "./pages/HostTokenAuthViewPage";
import LoginPage from "./pages/LoginPage";
import SSHEditPage from "./pages/SSHEditPage";
import SSHListPage from "./pages/SSHListPage";
import SSHViewPage from "./pages/SSHViewPage";
import TokenAuthEditPage from "./pages/TokenAuthEditPage";
import TokenAuthListPage from "./pages/TokenAuthListPage";
import TokenAuthViewPage from "./pages/TokenAuthViewPage";

function Router()
{
    let [, page_force_update] = useReducer((x) => x + 1, 0);

    let navigate = useNavigate();

    return <NSARouterMaker
        notifier_storage={new IStorageSession()}
        page_force_update={page_force_update}
        product_id={ProductUUID.NAMIRASOFT_CREDENTIAL}

        renderOnLogin={(result: NSARouterMakerResult) =>
        {
            let REACT_APP_BASE_URL_CREDENTIAL = new EnvService("REACT_APP_BASE_URL_CREDENTIAL", true).getString();

            let credential = new NamirasoftCredentialServer(REACT_APP_BASE_URL_CREDENTIAL, result.account.token_manager, result.notifier.onError);

            let servers = { credential };

            return (
                <FieldCacheService
                    {...result}
                    render={(rows) => (
                        <Routes>
                            <Route path={CredentialRoutes.Home} element={<HomePage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.AWSList} element={<AWSListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.AWSNew} element={<AWSEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.AWSCopy(":id")} element={<AWSEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.AWSEdit(":id")} element={<AWSEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.AWSView(":id")} element={<AWSViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.AzureList} element={<AzureListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.AzureNew} element={<AzureEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.AzureCopy(":id")} element={<AzureEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.AzureEdit(":id")} element={<AzureEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.AzureView(":id")} element={<AzureViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.BasicAuthList} element={<BasicAuthListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.BasicAuthNew} element={<BasicAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.BasicAuthCopy(":id")} element={<BasicAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.BasicAuthEdit(":id")} element={<BasicAuthEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.BasicAuthView(":id")} element={<BasicAuthViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.DatabaseList} element={<DatabaseListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.DatabaseNew} element={<DatabaseEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.DatabaseCopy(":id")} element={<DatabaseEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.DatabaseEdit(":id")} element={<DatabaseEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.DatabaseView(":id")} element={<DatabaseViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.GCPList} element={<GCPListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.GCPNew} element={<GCPEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GCPCopy(":id")} element={<GCPEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GCPEdit(":id")} element={<GCPEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.GCPView(":id")} element={<GCPViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.GitHubList} element={<GitHubListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.GitHubNew} element={<GitHubEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GitHubCopy(":id")} element={<GitHubEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GitHubEdit(":id")} element={<GitHubEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.GitHubView(":id")} element={<GitHubViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.GitLabList} element={<GitLabListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.GitLabNew} element={<GitLabEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GitLabCopy(":id")} element={<GitLabEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.GitLabEdit(":id")} element={<GitLabEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.GitLabView(":id")} element={<GitLabViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.TokenAuthList} element={<TokenAuthListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.TokenAuthNew} element={<TokenAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.TokenAuthCopy(":id")} element={<TokenAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.TokenAuthEdit(":id")} element={<TokenAuthEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.TokenAuthView(":id")} element={<TokenAuthViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.HostBasicAuthList} element={<HostBasicAuthListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.HostBasicAuthNew} element={<HostBasicAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.HostBasicAuthCopy(":id")} element={<HostBasicAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.HostBasicAuthEdit(":id")} element={<HostBasicAuthEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.HostBasicAuthView(":id")} element={<HostBasicAuthViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.HostTokenAuthList} element={<HostTokenAuthListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.HostTokenAuthNew} element={<HostTokenAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.HostTokenAuthCopy(":id")} element={<HostTokenAuthEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.HostTokenAuthEdit(":id")} element={<HostTokenAuthEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.HostTokenAuthView(":id")} element={<HostTokenAuthViewPage {...result} servers={servers} />} />

                            <Route path={CredentialRoutes.SSHList} element={<SSHListPage {...result} servers={servers} />} />
                            <Route path={CredentialRoutes.SSHNew} element={<SSHEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.SSHCopy(":id")} element={<SSHEditPage {...result} servers={servers} isEdit={false} />} />
                            <Route path={CredentialRoutes.SSHEdit(":id")} element={<SSHEditPage {...result} servers={servers} isEdit={true} />} />
                            <Route path={CredentialRoutes.SSHView(":id")} element={<SSHViewPage {...result} servers={servers} />} />

                            {NSFRouterMaker.getRoutes({ ...result, rows, children: <></> })}

                            <Route path="*" element={<NSNotFoundPage />} />
                        </Routes >
                    )}
                />
            );
        }}
        renderOnLogout={() => (
            <Routes>
                <Route path={CredentialRoutes.Home} element={<LoginPage />} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        )}
        navigate={navigate}
        getNSALayout={(props) => (
            <CredentialLayout {...props}>
                {props.children}
            </CredentialLayout>
        )}
        requirement={{
            verification: {
                email: false,
                phone: false
            }
        }}
    />
}

export default Router;